// Chakra imports
import { Text, useColorModeValue } from "@chakra-ui/react";
// Assets
import Project1 from "assets/img/profile/Project1.png";
import Project2 from "assets/img/profile/Project2.png";
import Project3 from "assets/img/profile/Project3.png";
// Custom components
import Card from "components/card/Card.js";
import React from "react";
import Project from "views/admin/profile/components/Project";

export default function Projects(props) {
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  return (
    <Card mb={{ base: "0px", "2xl": "20px" }}>
      <Text
        color={textColorPrimary}
        fontWeight='bold'
        fontSize='2xl'
        mt='10px'
        mb='4px'>
        News
      </Text>
      <Text color={textColorSecondary} fontSize='md' me='26px' mb='40px'>
        Últimas postagens da Hypr no Medium
      </Text>
      <Project
        boxShadow={cardShadow}
        mb='20px'
        image="https://miro.medium.com/fit/c/88/88/1*0NcJ2cwSxVPL61dDFUQ-Vw.png"
        ranking='1'
        link='#'
        title='Como garantir o contexto ideal e seguro para seus anúncios, sem perder escala e tempo com análises manuais e ineficientes?'
      />
      <Project
        boxShadow={cardShadow}
        mb='20px'
        image="https://miro.medium.com/fit/c/88/88/1*0NcJ2cwSxVPL61dDFUQ-Vw.png"
        ranking='2'
        link='#'
        title='Como as empresas de bens de consumo estão construindo um relacionamento direto com os consumidores através dos canais digitais'
      />
      <Project
        boxShadow={cardShadow}
        image="https://miro.medium.com/fit/c/112/112/0*rCR7ti1c3oULvAx9"
        ranking='3'
        link='#'
        title='Otimize Investimentos em Marketing de Influência'
      />
    </Card>
  );
}
